// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file github.com/pomerium/pomerium/pkg/grpc/config/config.proto (package pomerium.config, syntax proto3)
/* eslint-disable */

import { ConfigService } from "./config_pb";

/**
 * Creates a new key pair.
 *
 * @generated from rpc pomerium.config.ConfigService.CreateKeyPair
 */
export const createKeyPair = ConfigService.method.createKeyPair;

/**
 * Creates a new policy.
 *
 * @generated from rpc pomerium.config.ConfigService.CreatePolicy
 */
export const createPolicy = ConfigService.method.createPolicy;

/**
 * Creates a new route.
 *
 * @generated from rpc pomerium.config.ConfigService.CreateRoute
 */
export const createRoute = ConfigService.method.createRoute;

/**
 * Creates a new service account.
 *
 * @generated from rpc pomerium.config.ConfigService.CreateServiceAccount
 */
export const createServiceAccount = ConfigService.method.createServiceAccount;

/**
 * Deletes a key pair.
 *
 * @generated from rpc pomerium.config.ConfigService.DeleteKeyPair
 */
export const deleteKeyPair = ConfigService.method.deleteKeyPair;

/**
 * Deletes a policy.
 *
 * @generated from rpc pomerium.config.ConfigService.DeletePolicy
 */
export const deletePolicy = ConfigService.method.deletePolicy;

/**
 * Deletes a route.
 *
 * @generated from rpc pomerium.config.ConfigService.DeleteRoute
 */
export const deleteRoute = ConfigService.method.deleteRoute;

/**
 * Deletes a service account.
 *
 * @generated from rpc pomerium.config.ConfigService.DeleteServiceAccount
 */
export const deleteServiceAccount = ConfigService.method.deleteServiceAccount;

/**
 * Gets a key pair.
 *
 * @generated from rpc pomerium.config.ConfigService.GetKeyPair
 */
export const getKeyPair = ConfigService.method.getKeyPair;

/**
 * Gets a policy.
 *
 * @generated from rpc pomerium.config.ConfigService.GetPolicy
 */
export const getPolicy = ConfigService.method.getPolicy;

/**
 * Gets a route.
 *
 * @generated from rpc pomerium.config.ConfigService.GetRoute
 */
export const getRoute = ConfigService.method.getRoute;

/**
 * Gets information about a server.
 *
 * @generated from rpc pomerium.config.ConfigService.GetServerInfo
 */
export const getServerInfo = ConfigService.method.getServerInfo;

/**
 * Gets a service account.
 *
 * @generated from rpc pomerium.config.ConfigService.GetServiceAccount
 */
export const getServiceAccount = ConfigService.method.getServiceAccount;

/**
 * Gets settings.
 *
 * @generated from rpc pomerium.config.ConfigService.GetSettings
 */
export const getSettings = ConfigService.method.getSettings;

/**
 * Lists all the available log fields.
 *
 * @generated from rpc pomerium.config.ConfigService.ListAvailableLogFields
 */
export const listAvailableLogFields = ConfigService.method.listAvailableLogFields;

/**
 * Lists key pairs.
 *
 * @generated from rpc pomerium.config.ConfigService.ListKeyPairs
 */
export const listKeyPairs = ConfigService.method.listKeyPairs;

/**
 * Lists policies.
 *
 * @generated from rpc pomerium.config.ConfigService.ListPolicies
 */
export const listPolicies = ConfigService.method.listPolicies;

/**
 * Lists routes.
 *
 * @generated from rpc pomerium.config.ConfigService.ListRoutes
 */
export const listRoutes = ConfigService.method.listRoutes;

/**
 * Lists service accounts.
 *
 * @generated from rpc pomerium.config.ConfigService.ListServiceAccounts
 */
export const listServiceAccounts = ConfigService.method.listServiceAccounts;

/**
 * Lists settings.
 *
 * @generated from rpc pomerium.config.ConfigService.ListSettings
 */
export const listSettings = ConfigService.method.listSettings;

/**
 * Updates an existing key pair.
 *
 * @generated from rpc pomerium.config.ConfigService.UpdateKeyPair
 */
export const updateKeyPair = ConfigService.method.updateKeyPair;

/**
 * Updates an existing policy.
 *
 * @generated from rpc pomerium.config.ConfigService.UpdatePolicy
 */
export const updatePolicy = ConfigService.method.updatePolicy;

/**
 * Updates an existing route.
 *
 * @generated from rpc pomerium.config.ConfigService.UpdateRoute
 */
export const updateRoute = ConfigService.method.updateRoute;

/**
 * Updates an existing service account.
 *
 * @generated from rpc pomerium.config.ConfigService.UpdateServiceAccount
 */
export const updateServiceAccount = ConfigService.method.updateServiceAccount;

/**
 * Updates existing settings.
 *
 * @generated from rpc pomerium.config.ConfigService.UpdateSettings
 */
export const updateSettings = ConfigService.method.updateSettings;
